module.exports = __webpack_public_path__ + "static/media/portrait.1c295625.svg";